
import { Prop, Component, Vue } from "vue-property-decorator";
import { Bar } from "vue-chartjs";

@Component({
  extends: Bar
})
export default class BarChartBase extends Vue {
  @Prop(Object) chartData!: Object;
  @Prop(Object) options!: Object;

  mounted() {
    (this as any).renderChart(this.chartData, this.options);
  }


// mounted () {
//     // Overwriting base render method with actual data.
//     this.renderChart({
//      {
//         title: {
//           display: true,
//           text: 'Oversikt'
//         },
//         scales: {
//           yAxes: [{
//             stacked: true
//           }],
//           xAxes: [ {
//             stacked: true,
//             categoryPercentage: 0.5,
//             barPercentage: 1
//           }]
//         },
//         legend: {
//           display: true
//         },
//         responsive: true,
//         maintainAspectRatio: false
//       }
//     )
//   }
// }







}
